<div class="conteudo-exclusivo">
    <div class="py-5">
        <div class="headerPage">
            <div class="headerPageFilter">
                <div>
                    <i class="bi bi-star-fill custom-icon" [style.color]="labelColor"></i>
                    <h1 class="main-title" [style.color]="labelColor">
                        {{ sectionTitle }}
                    </h1>
                    <!-- <p *ngIf="showSubtitle" class="subtitle">{{ subtitleText }}</p> -->
                </div>

                <form class="search" [formGroup]="filterGroup" *ngIf="hasContent">
                    <input type="text" placeholder="Pesquisar conteúdo" formControlName="filterControl"
                        (keyup)="filter()" />
                </form>
            </div>
            <ng-container *ngIf="hasContent">
                <div class="filters">
                    <div class="ordernar-por mb-3">
                        <label>Ordenar por</label>
                        <select id="ordernarPor" [(ngModel)]="selectedOption" (change)="getExclusiveContent()">
                            <option *ngFor="let option of options" [ngValue]="option.code">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <button (click)="filterType('video')" [ngClass]="{ 'activeButton': typeActive === 'video' }"
                        class="mb-3" *ngIf="checkShowFilter('video')">
                        <img src="/assets/svg/filmWhite.svg" alt="film icon" />
                        <p>Vídeos</p>
                    </button>
                    <button (click)="filterType('image')" [ngClass]="{ 'activeButton': typeActive === 'image' }"
                        class="mb-3" *ngIf="checkShowFilter('image')">
                        <img src="/assets/svg/newspaperWhite.svg" alt="newspaper icon" />
                        <p>Matérias</p>
                    </button>
                    <button (click)="filterType('article')" [ngClass]="{ 'activeButton': typeActive === 'article' }"
                        class="mb-3" *ngIf="checkShowFilter('article')">
                        <img src="/assets/svg/newspaperWhite.svg" alt="newspaper icon" />
                        <p>Artigos</p>
                    </button>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="pagination">
                            <button (click)="prevPage()" [disabled]="currentPage === 0">
                                <i class="bi bi-arrow-left-circle-fill"></i>
                            </button>
                            <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
                                <button class="current-page" (click)="goToPage(i)" [class.active]="i === currentPage">
                                    {{ i + 1 }}
                                </button>
                            </ng-container>
                            <button (click)="nextPage()" [disabled]="currentPage === totalPages - 1">
                                <i class="bi bi-arrow-right-circle-fill"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="hasContent; else noContent">
            <app-carousel-simple title="Recomendado" colorTitle="white"
                [carouselData]="itemsRecommended"></app-carousel-simple>
            <app-carousel-simple title="Vídeos" colorTitle="white" [carouselData]="videoList"></app-carousel-simple>
            <app-carousel-simple title="Artigos" colorTitle="white" [carouselData]="articleList"></app-carousel-simple>
        </div>
        <ng-template #noContent>
            <div class="col-12 text-center py-1">
                <b>Não existem conteúdos exclusivos para visualização no momento</b>
            </div>
        </ng-template>
    </div>
</div>